// DO NOT EDIT THIS FILE!!!
// Update it by running `rake javascript:update_constants`

export const SEARCH_PRIORITIES = {
  ignore: 1,
  very_low: 2,
  low: 3,
  normal: 0,
  high: 4,
  very_high: 5,
};

export const SEARCH_PHRASE_REGEXP = '"([^"]+)"';

export const SIDEBAR_URL = {
  max_icon_length: 40,
  max_name_length: 80,
  max_value_length: 1000,
};

export const SIDEBAR_SECTION = {
  max_title_length: 30,
};

export const CATEGORY_STYLE_TYPES = { square: 0, icon: 1, emoji: 2 };

export const CATEGORY_TEXT_COLORS = ["FFFFFF", "000000"];

export const CATEGORY_ADDITIONAL_ASSIGN_ALLOWED_GROUPS =
  "additional_assign_allowed_on_groups";

// NOTE: Group names are changed based on the site's locale, see
// Group.refresh_automatic_group! for more details
export const AUTO_GROUPS = {
  everyone: { id: 0, automatic: true, name: "everyone" },
  admins: { id: 1, automatic: true, name: "admins" },
  moderators: { id: 2, automatic: true, name: "moderators" },
  staff: { id: 3, automatic: true, name: "staff" },
  anonymous_users: { id: 4, automatic: true, name: "anonymous_users" },
  logged_in_users: { id: 5, automatic: true, name: "logged_in_users" },
  trust_level_0: { id: 10, automatic: true, name: "trust_level_0" },
  trust_level_1: { id: 11, automatic: true, name: "trust_level_1" },
  trust_level_2: { id: 12, automatic: true, name: "trust_level_2" },
  trust_level_3: { id: 13, automatic: true, name: "trust_level_3" },
  trust_level_4: { id: 14, automatic: true, name: "trust_level_4" },
};

export const GROUP_SMTP_SSL_MODES = { none: 0, ssl_tls: 1, starttls: 2 };

export const GROUP_VISIBILITY_LEVELS = {
  public: 0,
  logged_on_users: 1,
  members: 2,
  staff: 3,
  owners: 4,
};

export const MAX_NOTIFICATIONS_LIMIT_PARAMS = 60;

export const TOPIC_VISIBILITY_REASONS = {
  op_flag_threshold_reached: 0,
  op_unhidden: 1,
  embedded_topic: 2,
  manually_unlisted: 3,
  manually_relisted: 4,
  bulk_action: 5,
  unknown: 99,
};

export const MAX_UNOPTIMIZED_CATEGORIES = 1000;

export const REVIEWABLE_UNKNOWN_TYPE_SOURCE = "unknown";

export const ADMIN_SEARCH_RESULT_TYPES = [
  "page",
  "setting",
  "theme",
  "component",
  "report",
  "upcomingChange",
];

export const API_KEY_SCOPE_MODES = ["global", "read_only", "granular"];

export const INVITE_DESCRIPTION_MAX_LENGTH = 100;

export const POSTING_REVIEW_GROUP_BASED_MODES = [
  "everyone_except",
  "no_one_except",
];

export const USER_OPTION_COMPOSITION_MODES = { markdown: 0, rich: 1 };

export const UPCOMING_CHANGES_USER_ENABLED_REASONS = {
  enabled_for_everyone: "enabled_for_everyone",
  enabled_for_no_one: "enabled_for_no_one",
  in_specific_groups: "in_specific_groups",
  not_in_specific_groups: "not_in_specific_groups",
};

export const INTERFACE_COLOR_MODES = {
  AUTO: 1,
  LIGHT: 2,
  DARK: 3,
};
